export default __webpack_public_path__ + "static/fmcg-scratch-to-win-88db432722fac1046c02137ae214b2a4.gif";